
import { AdminListings } from "@/components/admin/AdminListings";
import { AdminRouteGuard } from "@/components/admin/AdminRouteGuard";
import { Button } from "@/components/ui/button";
import { PlusCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function AdminListingsPage() {
  const navigate = useNavigate();

  return (
    <AdminRouteGuard requiredRole="superadmin">
      <div className="container py-8">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="text-2xl font-semibold tracking-tight">
              All Property Listings
            </h1>
            <p className="text-muted-foreground">
              Manage all property listings across the platform
            </p>
          </div>
          <Button onClick={() => navigate("/admin/create-listing")}>
            <PlusCircle className="mr-2 h-4 w-4" /> Add New Listing
          </Button>
        </div>

        <AdminListings />
      </div>
    </AdminRouteGuard>
  );
}
